import { Lobby } from './lobby';
import { Controller } from './controller';

export const LobbyV2 = () => {
  return (
    <div data-testid='lobby-v2-container' className='flex w-full flex-col gap-4 overflow-y-auto p-4 lg:flex-row lg:overflow-hidden'>
      {/* left panel */}
      <div data-testid='lobby-panel' className='order-2 flex h-[309px] w-full flex-none flex-col gap-4 lg:order-1 lg:h-full lg:w-96'>
        <Lobby />
      </div>
      {/* right panel */}
      <div data-testid='controller-panel' className='order-1 flex w-full flex-col gap-4 rounded-lg lg:order-2'>
        <Controller />
      </div>
    </div>
  );
};

